import { render, staticRenderFns } from "./ProgressWrapper.vue?vue&type=template&id=38beac06&"
import script from "./ProgressWrapper.vue?vue&type=script&lang=js&"
export * from "./ProgressWrapper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports